(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var cartEl = document.querySelector('cart-items');
    var notifArea = document.querySelector('.js-contents');

    if (sessionStorage.getItem('promo_item_removed')) {
      sessionStorage.removeItem('promo_item_removed');
      var msg = cartEl ? cartEl.dataset.promoOnlyMessage : '';
      if (msg) {
        var banner = document.createElement('div');
        banner.className = 'promo-cart-notification';
        banner.innerHTML =
          '<div class="promo-cart-notification__left">' +
          '<div class="promo-cart-notification__text"><p>' + msg + '</p></div>' +
          '</div>';
        if (cartEl && cartEl.classList.contains('is-empty')) {
          // Empty cart: .cart__contents (holding .js-contents) is display:none,
          // so inject at the top of the visible cart-items element instead.
          cartEl.insertBefore(banner, cartEl.firstChild);
        } else if (notifArea) {
          notifArea.insertBefore(banner, notifArea.firstChild);
        }
      }
    }

    // A promo_only line is legitimate only while its variant is a gift of a
    // currently-active offer. Anything else (no active offer, or an orphan from
    // an ended promo) is removed here. Ineligible-but-active gifts are left for
    // auto-add-offer.js to remove on eligibility grounds.
    var activeGiftIds = (window.__autoAddOffers || []).map(function (o) {
      return o.freeVariantId;
    });

    var flagged = Array.from(document.querySelectorAll('[data-promo-only-line]'))
      .filter(function (el) {
        return activeGiftIds.indexOf(parseInt(el.dataset.promoOnlyVariant, 10)) === -1;
      });
    if (!flagged.length) return;

    // Sort descending so removal of higher-indexed lines doesn't shift lower ones
    var lines = flagged
      .map(function (el) { return parseInt(el.dataset.promoOnlyLine, 10); })
      .sort(function (a, b) { return b - a; });

    function removeNext(remaining) {
      if (!remaining.length) {
        sessionStorage.setItem('promo_item_removed', '1');
        location.reload();
        return;
      }
      var line = remaining[0];
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function () {
        removeNext(remaining.slice(1));
      }).catch(function () {
        // Network error: leave item in cart, guard retries on next visit
      });
    }

    removeNext(lines);
  });
})();
